// extracted by mini-css-extract-plugin
module.exports = {"viewer":"styles_viewer__3yMih","header":"styles_header__kPqU2","title":"styles_title__Cgojk","frame":"styles_frame__2R7mT"};